import { render, staticRenderFns } from "./TestQuestion.vue?vue&type=template&id=0401754e&"
import script from "./TestQuestion.vue?vue&type=script&lang=ts&"
export * from "./TestQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports